import api from '@/apis'

export const fetchList = params => api.get(`/notify`, { params })
export const readUserNotify = (id) => api.put(`/notify/read/${id}`)
export const deleteNotify = (id) => api.delete(`/notify/${id}`)
export const getNotify = (id) => api.get(`/notify/${id}`)
export const addNotify = (data) => api.post(`/notify/add`, data)
export const updateNotify = (id, data) => api.post(`/notify/update/${id}`, data)
export const getUserNotify = (params) => api.get(`/notify/user/notifies`, { params });
export const deleteUserNotify = (id) => api.get(`/notify/delete_history/${id}`);
export const readUserAllNotify = (id) => api.put(`/notify/user/readAll`);
export const fetchNotifies = () => api.get(`/notify/user/unReadCount`)

export const fetchSpList = (params) => api.get(`/tip/sp/list`, { params })
export const deleteSpitem = (id) => api.delete(`/tip/sp/delete/${id}`)

export const fetchFeedbackList = (params) => api.get(`/feedback/findAll`, { params })
export const deleteFeedbackitem = (id) => api.delete(`/feedback/${id}/delete`)
export const ignoreFeedbackitem = (id) => api.put(`/feedback/${id}/ignore`)
export const feedbackReply = (data) => api.put(`/feedback/${data.id}/reply`, data);
export const fetchNoDoFeedback = (params) => api.get(`/noDoFeedback`, { params })